import SelectDropdown from '@/components/Select/SelectDropdown';
import { PropertyValueStyle } from '@/components/Typography/PropertyValue';
import SentimentBadge from '@/features/Feedback/field/Sentiment/SentimentBadge';
import { sentimentsOptions } from '@/types/feedbackConst';

export interface Props {
  feedbackKey: string;
  useShortcut?: boolean;
  selected?: number;
  name: string;
  onSelect: (key: string | number) => void;
}

const SentimentDropdown = ({
  selected,
  name,
  useShortcut,
  onSelect,
}: Props) => {
  return (
    <SelectDropdown
      name={name}
      data={sentimentsOptions}
      customMapper={(value) => {
        if (!value)
          return <PropertyValueStyle>Not applicable</PropertyValueStyle>;
        return <SentimentBadge type={Number(value)} />;
      }}
      mapper={(op) => {
        return <SentimentBadge type={Number(op.value)} />;
      }}
      searchOptions={{
        enable: true,
      }}
      value={String(selected)}
      onSelect={onSelect}
      shortcut={useShortcut ? 'KeyS' : ''}
    />
  );
};

export default SentimentDropdown;
